import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { partnerKeys } from '@/api/query-keys';
import { listPartnerLeadsContract, type ListPartnerLeadsResponse } from '@bliks-io/contracts';

/**
 * Fetch the HubSpot leads assigned to the authenticated partner.
 *
 * `staleTime: 0` keeps the data fresh on every visit to the partner dashboard
 * (no live polling — a manual refresh via `refetch()` covers in-session updates).
 */
export function usePartnerLeads() {
  return useQuery({
    queryKey: partnerKeys.leads(),
    queryFn: async ({ signal }): Promise<ListPartnerLeadsResponse> => {
      // 403 (not linked to HubSpot) renders as a friendly panel on the pages.
      const { data } = await apiClient.get<ListPartnerLeadsResponse>(
        listPartnerLeadsContract.path,
        { signal, suppressForbiddenToast: true }
      );
      return data;
    },
    staleTime: 0
  });
}
